import { DropdownItem } from '../../_shared/ui-components/YogaUI/alo-ui/AloDropdown';
import sortDropdownStyles from '../../_shared/ui-components/YogaUI/alo-ui/AloDropdown/sorting.module.scss';

// --  fixed strings vs symbols?

export const SORT_BY_KEY = 'sort_by';

export const getSortStyle = (value: DropdownItem) => {
  const inputRootClass =
    value?.key !== 'SORT' ? sortDropdownStyles.sortingInputRootSelected : sortDropdownStyles.sortingInputRoot;
  return {
    inputRoot: inputRootClass,
    input: sortDropdownStyles.sortingInputRoot,
    option: sortDropdownStyles.sortingOption,
    root: sortDropdownStyles.sortingRoot,
    popupIndicator: sortDropdownStyles.sortingPopupIndicator,
    paper: sortDropdownStyles.sortingPaper,
    popper: sortDropdownStyles.sortingPopper,
  };
};
